import React, { createElement, useState, useEffect } from "react";
import { LayerGroup, LayersControl, Polyline, MapContainer, TileLayer, useMap, useMapEvents, Marker, Popup } from "react-leaflet";
import * as api from '../../api/index';
import useAxiosData from '../../hooks/useAxiosData';
import L from 'leaflet';

import goldMapThumbnail from '../../assets/webp/goldMapThumbnail.webp';
import greenMapThumbnail from '../../assets/webp/greenMapThumbnail.webp';
import grayMapThumbnail from '../../assets/webp/grayMapThumbnail.webp';

function Trail({ name, color, positions, control = true, show = false }) {
    const layerRef = React.useRef();

    return createElement(
        control ? LayersControl.Overlay : React.Fragment,
        control ? { checked: show, name } : null,
        positions.length > 0 &&
        <LayerGroup ref={layerRef}>
            <Polyline weight={5} color={color} positions={[...positions, positions[0]]} />
        </LayerGroup>
    );
}

function LockMapBounds() {
    const map = useMap();
    useEffect(() => {
        map.setMaxBounds(map.getBounds());
    }, []);
}

function FixInitialBounds({ bounds, options }) {
    const map = useMap();

    useEffect(() => {
        map.flyToBounds(bounds, options);
    }, []);
}

function TrailIncrementListener() {
    useMapEvents({
        overlayadd(e) {
            if (e.name !== "Benches") {
                api.incrementTrailUsage(e.name);
            }
        },
    });
}

export default function TrailsMap({ children, layerChildren, showTrails = true, userMode }) {
    const [trailData, status] = useAxiosData(api.fetchTrails, []);
    const [visibleTrailId, setVisibleTrailId] = useState(null);

    const handleTrailButtonClick = (trailId) => {
        setVisibleTrailId(prevId => {
            const isTurningOn = prevId !== trailId;

            if (isTurningOn) {
                const trail = trailData.find(t => t._id === trailId);
                if (trail && trail.name !== "Benches") {
                    api.incrementTrailUsage(trail.name);
                }
            }

            return isTurningOn ? trailId : null;
        });
    };

    return (
        <div className="container-xl">
            <div>
                {status === "success" && (
                    <MapContainer
                        id="map-view"
                        center={[33.98044217307206, -84.00403469429018]}
                        minZoom={14}
                        maxZoom={17}
                        style={{ height: '500px', width: '100%' }}
                    >
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />

                        <FixInitialBounds bounds={[[33.982891, -84.004648], [33.980314, -83.998223] ,[33.977146, -84.004260],[33.979897, -84.010709]]} options={{ animate: false }} />
                        <LockMapBounds />

                        {userMode && <TrailIncrementListener />}
                        {children}

                        {showTrails && (
                            <LayersControl position="bottomright">
                                {layerChildren}
                                {visibleTrailId &&
                                    trailData
                                        .filter(trail => trail._id === visibleTrailId)
                                        .map(trail => (
                                            <Trail
                                                key={trail._id}
                                                name={trail.name}
                                                color={trail.color}
                                                positions={trail.path.coordinates.map(([lng, lat]) => ({ lat, lng }))}
                                                control={true}
                                                show={visibleTrailId === trail._id}
                                            />
                                        ))
                                }
                            </LayersControl>
                        )}
                    </MapContainer>
                )}
            </div>


            <div className="container my-4">
                <div className="row justify-content-center my-4">
                    <div className="col-12 col-sm-12 col-md-4 mb-3">
                        <button
                            aria-label="Gold Trail Button"
                            onClick={() => handleTrailButtonClick('673e9addbf9ebe061ef810bf')}
                            className="btn btn-trail btn-gold w-100"
                            style={{ backgroundImage: `url(${goldMapThumbnail})` }}
                        />
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 mb-3">
                        <button
                            aria-label="Green Trail Button"
                            onClick={() => handleTrailButtonClick('673e9addbf9ebe061ef810c1')}
                            className="btn btn-trail btn-green w-100"
                            style={{ backgroundImage: `url(${greenMapThumbnail})` }}
                        />
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 mb-3">
                        <button
                            aria-label="Gray Trail Button"
                            onClick={() => handleTrailButtonClick('673e9addbf9ebe061ef810c0')}
                            className="btn btn-trail btn-gray w-100"
                            style={{ backgroundImage: `url(${grayMapThumbnail})` }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
